import { createFeatureSelector, createSelector } from '@ngrx/store';
import { hasIn } from 'lodash';
// import { selectConsulateModuleState } from '../../reducers';
import { selectAccountState } from '../../reducers';
import { AccountState } from './account.reducer';

export const selectAdminAccountState = createSelector(
  selectAccountState,
  (state) => state.adminAccount
);

/**
 * Is user authenticated
 */
export const isAuth = createSelector(
  selectAccountState,
  (state: AccountState) => hasIn(state.adminAccount, 'accountId')
);

/**
 * Is user not authenticated?
 */
export const isNotAuth = createSelector(isAuth, (authed) => !authed);

export const isAuthenticating = createSelector(
  selectAccountState,
  (state: AccountState) => state.isLoading
);

/**
 * Is OXIO admin?
 */
export const isOxioAdmin = createSelector(
  selectAccountState,
  (state: AccountState) => state.isOxioAdmin
);

/**
 * Get account type
 */
export const accountType = createSelector(
  selectAccountState,
  (state: AccountState) => state.adminAccount.accountType
);

/**
 * Get user full name
 */
export const fullName = createSelector(
  selectAccountState,
  (state: AccountState) => {
    let fullName;

    const hasFirstName = hasIn(state.adminAccount, 'firstname');

    if (hasIn(state.adminAccount, 'lastname')) {
      if (hasFirstName) {
        fullName = `${state.adminAccount.firstname} ${state.adminAccount.lastname}`;
      } else {
        fullName = state.adminAccount.lastname;
      }
    }

    return fullName;
  }
);

/**
 * Get user permissions
 */
export const permissions = createSelector(
  selectAccountState,
  (state: AccountState) => {
    if (hasIn(state, 'permissions.rules')) return state.permissions.rules;
  }
);

/**
 * Get stored permissions
 */
export const getStoredPermissions = createSelector(
  selectAccountState,
  (state: AccountState) => state.storedPermissions
);
